import { BaseActionObject, StateNodeConfig, assign } from "xstate4"
import { Context, Transitions } from "../../types"

export const confirmLeaveState: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  entry: assign<Context>({
    confirmLeaveModal: true
  }),
  exit: assign<Context>({
    confirmLeaveModal: false
  }),
  on: {
    CONFIRM: {
      // Always go through cancel_plan_transition, which will handle pending program change
      target: "#StudyPlan.cancel_plan_transition"
    },
    CANCEL: {
      target: "idle",
      actions: assign<Context>({
        pendingProgramChange: null,
        pendingNavigationUrl: null
      })
    },
    LEAVE: {
      // Stay in confirm_leave state but update the pending navigation URL if provided
      // This prevents the modal from closing when navigation is attempted while already showing
      actions: assign<Context>(
        (ctx, evt: { type: "LEAVE"; location?: string }) => {
          return {
            pendingNavigationUrl: evt.location ?? ctx.pendingNavigationUrl
          }
        }
      )
    }
  }
}
